export default  {
  apiKey: "AIzaSyCgcfh_dnM82Uyy0ug3sDgRKOpa9RdQ49Y",
  authDomain: "kings-county-hospital.firebaseapp.com",
  databaseURL: "https://kings-county-hospital.firebaseio.com",
  projectId: "kings-county-hospital",
  storageBucket: "kings-county-hospital.appspot.com",
  messagingSenderId: "827312213330",
  appId: "1:827312213330:web:a91bcd2fa24758cb5cbe8b",
  measurementId: "G-DZ7KS65GWJ"
};
